import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { LanguageProvider } from './context/LanguageContext';
import { BackgroundProvider } from './context/BackgroundContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import { OrganizationStructuredData, WebsiteStructuredData } from './components/common/StructuredData';
import ScrollProgress from './components/common/ScrollProgress';
import AnimatedBackground from './components/common/AnimatedBackground';

// Lazy Loading Pages
const Home = lazy(() => import('./pages/Home'));
const Contact = lazy(() => import('./pages/Contact'));
const CarsidanAl = lazy(() => import('./pages/CarsidanAl'));
const PaylasCozulsun = lazy(() => import('./pages/PaylasCozulsun'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const NotFound = lazy(() => import('./pages/NotFound'));

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top-color: #fff;
  animation: ${spin} 1s ease-in-out infinite;
`;

const LoadingFallback = () => (
  <LoadingWrapper>
    <Spinner />
  </LoadingWrapper>
);

function App() {
  return (
    <LanguageProvider>
      <BackgroundProvider>
        <Router>
          <div className="App">
            <AnimatedBackground />
            <ScrollProgress />
            <OrganizationStructuredData />
            <WebsiteStructuredData />
            <Navbar />
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/products/carsidan-al" element={<CarsidanAl />} />
                <Route path="/products/paylas-cozulsun" element={<PaylasCozulsun />} />
                <Route path="/legal/:appId/:type" element={<LegalPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
            <Footer />
          </div>
        </Router>
      </BackgroundProvider>
    </LanguageProvider>
  );
}

export default App; 